/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnforcementSignalRecord } from './enforcementSignalRecord';


export interface EnforcementSignalResponse { 
    enforcement_signal_records?: Array<EnforcementSignalRecord>;
    total_record_count?: number;
}

